import { Component, OnInit, Input } from '@angular/core';
import { RecPlanSearchService } from '../../../rec-plan-search/rec-plan-search-service';
import { GetSBImagesQuery, SBListDTO, basketVM } from '../../viewmodels/ISearchServiceReg';

declare global {
  interface Navigator {
    msSaveOrOpenBlob: (blobOrBase64: Blob | string, filename: string) => void
  }
}

@Component({
  selector: 'app-plan-download',
  providers:[RecPlanSearchService],
  templateUrl: './plan-download.component.html',
  styleUrls: ['./plan-download.component.css']
})
export class PlanDownloadComponent implements OnInit {

  @Input() planImages: Array<string>;
  @Input() pagecount: number;
  @Input() planname: string;
  @Input() currentindex: number;
  @Input() book: string;
  @Input() page: string;
  basketItems: Array<basketVM>;
  basketItem: basketVM;
  docImages: any;
  error: any;
  popupVisible: boolean = false;
  Message: string;

  constructor(private service: RecPlanSearchService) {
    this.basketItems = new Array<basketVM>();

    if (localStorage.getItem("basket") !== null && localStorage.getItem("basket").length > 0) {
      this.basketItems = JSON.parse(localStorage.getItem("basket"));
    }
  }

  ngOnInit() {
  }

  addToBasket(iswholedoc: boolean) {
    console.log("add to basket");
    console.log("planname" + this.planname);
    var index: number;
    if (this.planname !== undefined)
      index = this.basketItems.findIndex(item => item.planname === this.planname && item.wholeDoc === iswholedoc);
    else
      index = this.basketItems.findIndex(item => item.book === this.book && item.page === this.page && item.wholeDoc === iswholedoc);
    ////exists
    if (index > -1) {
      if (iswholedoc) {
        console.log("Duplicate entry");
        if (this.planname !== undefined)
          this.Message = "Plan " + this.planname + " is already added.";
        else
          this.Message = "Plan Book/Page " + this.book + "/" + this.page + " is already added.";
        this.popupVisible = true;
      }
      else {
        if (this.planname !== undefined && this.basketItems[index].pages.indexOf((this.currentindex - 1).toString()) > -1) {
          this.Message = "Plan " + this.planname + ", p." + (this.currentindex) + " is already added.";
          this.popupVisible = true;
        }
        else if (this.planname === undefined && this.basketItems[index].pages.indexOf((this.currentindex -1).toString()) > -1) {
          this.Message = "Plan Book/Page " + this.book + "/" + this.page + ", p." + (this.currentindex) + " is already added.";
          this.popupVisible = true;
        }
        else {
          this.basketItems[index].pageCount = this.basketItems[index].pageCount + 1;
          //update local storage
          let basketls = JSON.parse(localStorage.getItem("planbasket"));
          basketls[index].pageCount = basketls[index].pageCount + 1;
          localStorage.setItem("planbasket", JSON.stringify(basketls));

          if (this.planname !== undefined) {
            this.basketItems[index].imagepaths.push(this.planImages[this.currentindex - 1]);
            this.basketItems[index].pages.push((this.currentindex - 1).toString());
            //update local storage
            let basketls = JSON.parse(localStorage.getItem("planbasket"));
            basketls[index].imagepaths.push(this.planImages[this.currentindex - 1]);
            basketls[index].pages.push((this.currentindex - 1).toString());
            localStorage.setItem("planbasket", JSON.stringify(basketls));
            this.Message = "Plan " + this.planname + ", p." + (this.currentindex) + " is added successfully.";
          }
          else {
            this.basketItems[index].imagepaths.push(this.planImages[this.currentindex - 1]);
            this.basketItems[index].pages.push((this.currentindex -1).toString());
            //update local storage
            let basketls = JSON.parse(localStorage.getItem("planbasket"));
            basketls[index].imagepaths.push(this.planImages[this.currentindex - 1]);
            basketls[index].pages.push((this.currentindex -1).toString());
            localStorage.setItem("planbasket", JSON.stringify(basketls));
            this.Message = "Plan Book/Page " + this.book + "/" + this.page + ", p." + (this.currentindex) + " is added successfully.";
          }
          this.popupVisible = true;
        }
      }
    }

    ////not exists- create new basket item
    else {
      this.basketItem = new basketVM();
      //this.basketItem.docType = this.doctype;

      //// Registered land plans
      if (this.planname !== undefined) {
        this.basketItem.planname = this.planname;
        this.basketItem.document = this.planname;
       // this.basketItem.docId = this.docId.toString();
        //this.basketItem.dept = 'L';
      }

      ////Recorded land plans
      else {
        this.basketItem.book = this.book;
        this.basketItem.page = this.page;
        this.basketItem.document = 'B:' + this.book + '/P:' + this.page;
        //this.basketItem.dept = 'R';
      }
      this.basketItem.isEmail = false;
      this.basketItem.isDownload = false;
      this.basketItem.downloadAs = 'pdf';
      this.basketItem.wholeDoc = iswholedoc;
      
      if (iswholedoc) {
        this.basketItem.pageCount = this.pagecount;
        this.basketItem.imagepaths = this.planImages;
      }
      else {
        this.basketItem.pageCount = 1;
        if (this.planname !== undefined) {
          this.basketItem.imagepaths = new Array<string>(this.planImages[this.currentindex - 1]);
          this.basketItem.pages = new Array<string>((this.currentindex - 1).toString());
        }
        else {
          this.basketItem.imagepaths = new Array<string>(this.planImages[this.currentindex - 1]);
          this.basketItem.pages = new Array<string>((this.currentindex -1).toString());
        }
         
      }
      this.basketItems.push(this.basketItem);

      //update local storage
      if (localStorage.getItem("planbasket") !== null && localStorage.getItem("planbasket").length > 0) {
        let basketls = JSON.parse(localStorage.getItem("planbasket"));
        basketls.push(this.basketItem);
        localStorage.setItem("planbasket", JSON.stringify(basketls));
      }

      if (iswholedoc)
        if (this.planname !== undefined)
          this.Message = "Plan " + this.planname + " is added successfully.";
        else
          this.Message = "Plan Book/Page " + this.book + "/" + this.page + " is added successfully.";
      else
          if (this.planname !== undefined)
            this.Message = "Plan " + this.planname + ", p." + (this.currentindex) + " is added successfully.";
        else
          this.Message = "Plan Book/Page " + this.book + "/" + this.page + ", p." + (this.currentindex) + " is added successfully.";
      this.popupVisible = true;
    }

  }

  getBasket() {
    console.log("display basket");
  }

  downloadPDF() {
    var sblist: SBListDTO[] = new Array<SBListDTO>();
    
    this.basketItems.forEach(function (bi) {
      if (bi.isDownload) {
        var sb1 = new SBListDTO();
        sb1.imageType = bi.downloadAs;
        sb1.department = bi.dept;
        sb1.wholeDoc = bi.wholeDoc;
        sb1.pages = bi.imagepaths;
        sblist.push(sb1);
      }
    });
    console.log(sblist);
    if (sblist.length > 0) {
      let imgquery = new GetSBImagesQuery({
        emailList: false,
        emailAddress: '',
        zipList: false,
        sBList: sblist

      });

      console.log("Calling download" + imgquery);
      this.service.DownloadPlans(imgquery).subscribe(
        data => {
          this.docImages = data;
          console.log('planbasket' + this.docImages);
          this.basketItems = this.basketItems.filter(item => item.isDownload == false);
          if (localStorage.getItem("planbasket") !== null && localStorage.getItem("planbasket").length > 0) {
            let basketls = JSON.parse(localStorage.getItem("planbasket"));
            localStorage.setItem("planbasket", JSON.stringify(basketls.filter(item => item.isDownload == true)));
          }

          ////const url = window.URL.createObjectURL(this.docImages);
          ////window.open(url);
          //////window.URL.revokeObjectURL(url);

          //IE11 support
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(this.docImages, "MyZipfile.zip");
          }
          // other browsers
          else {
            var a = document.createElement("a");
            document.body.appendChild(a);
            const url = window.URL.createObjectURL(this.docImages);
            a.href = url;
            a.download = "MyZipfile.zip";
            a.click();
            window.URL.revokeObjectURL(url);
          }
        },
        error => { this.error = error }
      );

    }

    else
      console.log('Select item to download');

  }

  deleteRow(event) {
    if (localStorage.getItem("planbasket") !== null && localStorage.getItem("planbasket").length > 0) {
      let basketls = JSON.parse(localStorage.getItem("planbasket"));
      localStorage.setItem("planbasket", JSON.stringify(basketls.filter(item => item.bookpage !== event.key.bookpage)));
    }
  }

}
